export enum ETelemetryEvents {
  CompanyPageStart = 'company-page.start',
  CompanyPageFailed = 'company-page.failed',
}
